import { Paper } from "@mantine/core";
import { Headers } from "../components/ui/heading";
import useBulkUploadsStore from "../stores/bulkUploadsStore";
import BatchSummaryPage from "../components/BulkUploads/BatchSummary/BatchSummaryPage";
import useUserRole from "../components/Transactions/hooks/useUserRole";

function BatchSummary() {
  const { selectedBatch } = useBulkUploadsStore();
  const { isSuperAdmin } = useUserRole();

  return (
    <div className="-m-4 min-h-screen flex flex-col pb-16 bg-white-700">
      <Paper shadow="xs" p={{ base: "sm", sm: "xl" }}>
        <div className="flex-shrink-0 [&>div]:mb-0">
          <Headers
            name="Summary Report"
            additionalInfo={
              selectedBatch?.batchId
                ? `Batch ${selectedBatch.batchId} • Real-time overview of processing activity.`
                : null
            }
          />
        </div>
      </Paper>
      <BatchSummaryPage id={selectedBatch?.id} isSuperAdmin={isSuperAdmin} />
    </div>
  );
}

export default BatchSummary;
